import WidgetItemId               from "../../../widget/item/WidgetItemId";
import WidgetItemTitle            from "../../../widget/item/WidgetItemTitle";
import WidgetItemValue            from "../../../widget/item/WidgetItemValue";
import CustomerRecordWidgetItemId from "./CustomerRecordWidgetItemId";

class CustomerRecordWidgetItem {
  constructor(
    private readonly _id: CustomerRecordWidgetItemId = new CustomerRecordWidgetItemId(),
    private readonly _widgetItemId: WidgetItemId = new WidgetItemId(),
    private readonly _title: WidgetItemTitle = new WidgetItemTitle(),
    private readonly _value: WidgetItemValue = new WidgetItemValue()
  ) {
  }

  get id() {
    return this._id;
  }

  get widgetItemId() {
    return this._widgetItemId;
  }

  get title() {
    return this._title;
  }

  get value() {
    return this._value;
  }
}

export default CustomerRecordWidgetItem;
